/** @format */

import axios from 'axios'

import { notification } from 'antd'

export default async function serviceUploadFile(item) {
	const form = new FormData()
	form.append('file', item.file)
	let returnResponse
	await axios({
		method: 'POST',
		url: `${
			process.env.REACT_APP_FUNCTION_CHECKOUT
		}/upload/${process.env.REACT_APP___COUNTRY.toLowerCase()}/${item.typeFile.toLowerCase()}`,
		headers: { 'Content-Type': 'multipart/form-data' },
		data: form,
	})
		.then(async (response) => {
			if (response.data.statusCode === 200) {
				returnResponse = response.data
			} else {
				notification.error({
					message: response.data.error,
					description: response.data.message,
				})
			}
		})
		.catch((error) => {
			notification.error({
				message: 'Error de servicio',
				description: `${
					process.env.REACT_APP_FUNCTION_PANEL_TRACKING
				}/upload/${process.env.REACT_APP___COUNTRY.toLowerCase()}/${item.typeFile.toLowerCase()}`,
			})
		})

	return returnResponse
}
